import { scrollToElement } from '../Utility/ScrollUtility';

export class ArticleController {
  private readonly scrollToProductsElement: HTMLElement | null = document.querySelector('.js-scroll-to-products');
  private readonly productsElement: HTMLElement | null = document.querySelector('.js-products');
  private readonly mobileShareElement: HTMLElement | null = document.querySelector('.js-mobile-share');

  constructor() {
    if (this.scrollToProductsElement && this.productsElement) {
      this.scrollToProductsElement.addEventListener('click', () => {
        if (this.productsElement) {
          scrollToElement(this.productsElement);
        }
      });
    }
    if (this.mobileShareElement) {
      this.mobileShareElement.addEventListener('click', async () => {
        try {
          await navigator.share({url: window.location.href});
        } catch (error) {
          console.error(error);
        }
      });
    }
  }
}
